export default __webpack_public_path__ + "static/media/lady.168330f3.png";